<div class="header-bar">
  <h1 *ngIf="isCustomer">Customer Bespoke Agreements</h1>
  <h1 *ngIf="!isCustomer">Supplier Bespoke Agreements</h1>
</div>
<div class="content-container">
  <div class="filterPanel mb-3">
    <div class="flex grid-gap-15">
      <div class="pt-1">
        <input pInputText [(ngModel)]="searchCustomer" placeholder="Organisation" />
      </div>
      <div class="pt-1">
        <input pInputText [(ngModel)]="searchDepartment" placeholder="Department" />
      </div>
      <div>
        <button
          class="ui-button-secondary"
          pButton
          label="Reset"
          icon="fa fa-undo"
          (click)="reset()"
        ></button>
        <button pButton label="Search" icon="fa fa-search" (click)="search()"></button>
      </div>
    </div>
  </div>

  <div *ngIf="isLoaded; else loading">
    <p-table
      #dt
      selectionMode="single"
      [(selection)]="selectedItem"
      [value]="page.items"
      [lazy]="true"
      [rows]="10"
      [responsive]="true"
      [paginator]="true"
      rowHover="true"
      resizableColumns="true"
      [rowsPerPageOptions]="[5, 10, 20]"
      [pageLinks]="3"
      [totalRecords]="page.total"
      (onLazyLoad)="onGridLazyLoad($event)"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="organisationName">Organisation</th>
          <th *ngIf="isCustomer" pSortableColumn="departmentName">Department</th>
          <th pSortableColumn="createdOn">Created On</th>
          <th pSortableColumn="updatedOn">Updated On</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr (dblclick)="gotoAgreement(item)" [pSelectableRow]="item">
          <td>{{ item.organisationName }}</td>
          <td *ngIf="isCustomer">{{ item.departmentName }}</td>
          <td>{{ item.createdOn | date : 'dd/MM/y' }}</td>
          <td>{{ item.updatedOn | date : 'dd/MM/y' }}</td>
        </tr>
      </ng-template>
    </p-table>

    <!--- DEPRECATED ---
    <p-dataTabl #dt selectionMode="single" [(selection)]="selectedItem" [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true"
                 [paginator]="true" rowHover="true" resizableColumns="true" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3" [totalRecords]="page.total"
                 (onLazyLoad)="onGridLazyLoad($event)" (onRowDblclick)="gotoAgreement(selectedItem)"
                 >
        <p-column field="organisationName" header="Organisation" [sortable]="tru" [editable]="false"></p-column>
        <p-column field="createdOn" header="Created On" [sortable]="tru" [editable]="false">
            <ng-template pTemplate="body" let-item="rowData">
                {{item.createdOn | date:'dd/MM/y'}}
            </ng-template>
        </p-column>
        <p-column field="updatedOn" header="Updated On" [sortable]="tru" [editable]="false">
            <ng-template pTemplate="body" let-item="rowData">
                {{item.updatedOn | date:'dd/MM/y'}}
            </ng-template>
        </p-column>
    </p-dataTable>

    -->

    <div class="footerPanel ui-grid-row">
      <button
        type="button"
        class="ui-button-danger btn-to-right"
        (click)="deleteDialog(selectedItem)"
        label="Remove"
        pButton
        icon="fa ui-icon-delete"
        [disabled]="!selectedItem || !isPricingAdmin"
      ></button>
      <button
        type="button"
        class="btn-to-right"
        (click)="gotoAgreement(selectedItem)"
        label="Edit"
        pButton
        icon="fa ui-icon-mode-edit"
        [disabled]="!selectedItem || !isPricingAdmin"
      ></button>
      <button
        type="button"
        class="btn-to-right"
        pButton
        icon="fa ui-icon-add"
        (click)="addAgreement()"
        label="Add"
        [disabled]="!isPricingAdmin"
      ></button>
    </div>
  </div>
  <p-dialog
    header="New Bespoke Agreement"
    [(visible)]="showViewDialog"
    [responsive]="true"
    [modal]="true"
    [style]="{ width: '500px' }"
  >
    <div class="ui-grid ui-grid-responsive ui-fluid">
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="name">Organisation</label></div>
        <div class="ui-g-8">
          <p-dropdown
            id="name"
            [filter]="true"
            appendTo="body"
            placeholder="Select an organisation"
            [options]="orgsForBespoke"
            [(ngModel)]="dlgSelectedOrgId"
            autoWidth="false"
            (ngModelChange)="onSelectedOrgChanged()"
            [style]="{ width: '100%' }"
          ></p-dropdown>
        </div>
      </div>

      <div class="ui-g-12" *ngIf="isCustomer && dlgSelectedOrgId && deptsForBespoke?.length > 0">
        <div class="ui-g-4"><label for="dept">Department</label></div>
        <div class="ui-g-8">
          <p-dropdown
            id="dept"
            [filter]="true"
            appendTo="body"
            placeholder="Select a department"
            [options]="deptsForBespoke"
            [(ngModel)]="dlgSelectedDeptId"
            [style]="{ width: '100%' }"
          ></p-dropdown>
        </div>
      </div>
    </div>

    <div style="float: right; margin-top: 50px">
      <button
        type="button"
        class="green-btn"
        pButton
        label="Create"
        [disabled]="!dlgSelectedOrgId"
        (click)="createAgreement()"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Close"
        (click)="closeViewDialog()"
      ></button>
    </div>
  </p-dialog>
</div>
<ng-template #loading>Loading...</ng-template>

<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Confirm"
  rejectLabel="Cancel"
></p-confirmDialog>
